<template>
	<div class="id-card-mask">
		<span class="id-display">{{ displayedId }}</span>
		<span v-if="showToggle" class="eye-icon" @click="toggleVisible" :title="isRevealed ? '已显示，3秒后自动隐藏' : '显示完整身份证'">
			👁️
		</span>
	</div>
</template>

<script>
	export default {
		name: 'IdCardMask',
		props: {
			value: {
				type: String,
				required: true
			},
			showToggle: {
				type: Boolean,
				default: true
			},
			// 是否启用自动隐藏（默认 true）
			autoHide: {
				type: Boolean,
				default: true
			},
			// 自动隐藏延迟时间（毫秒，默认 3000 = 3秒）
			hideDelay: {
				type: Number,
				default: 3000
			}
		},
		data() {
			return {
				isRevealed: false,
				hideTimer: null // 存储 setTimeout 的引用
			}
		},
		computed: {
			displayedId() {
				if (this.isRevealed) {
					return this.value // 直接显示完整身份证
				}
				if (!this.value || this.value.length < 11) {
					return this.value
				}
				return this.value.substring(0, 4) + '********' + this.value.substring(this.value.length - 2)
			}
		},
		methods: {
			toggleVisible() {
				if (this.isRevealed) {
					// 如果已经显示，手动点击则立即隐藏（可选）
					this.hideImmediately()
				} else {
					// 显示完整身份证
					this.isRevealed = true

					// 如果启用了自动隐藏
					if (this.autoHide) {
						// 先清除之前的定时器（防重复）
						this.clearHideTimer()

						// 设置新的自动隐藏定时器
						this.hideTimer = setTimeout(() => {
							this.isRevealed = false
							this.hideTimer = null
						}, this.hideDelay)
					}
				}
			},

			// 立即隐藏（用于手动关闭或清理）
			hideImmediately() {
				this.isRevealed = false
				this.clearHideTimer()
			},

			// 清除定时器
			clearHideTimer() {
				if (this.hideTimer) {
					clearTimeout(this.hideTimer)
					this.hideTimer = null
				}
			}
		},

		// 组件销毁时清理定时器（防止内存泄漏）
		beforeDestroy() {
			this.clearHideTimer()
		},

		// 监听外部 value 变化（可选：值变了就自动隐藏）
		watch: {
			value() {
				this.hideImmediately()
			}
		}
	}
</script>

<style scoped>
	.id-card-mask {
		display: inline-flex;
		align-items: center;
		font-family: monospace;
		font-size: 16px;
		letter-spacing: 1px;
	}

	.id-display {
		padding: 6px 10px;
		border: 1px solid #ddd;
		border-radius: 4px;
		background-color: #f8f9fa;
		min-width: 180px;
		text-align: center;
	}

	.eye-icon {
		margin-left: 8px;
		cursor: pointer;
		color: #6c757d;
		font-size: 18px;
		user-select: none;
		transition: color 0.2s;
	}

	.eye-icon:hover {
		color: #0d6efd;
	}
</style>